
import React, { useEffect, useRef, useState } from 'react';
import TakeLookTopSection from '../../../components/TakeALook/TakeLookTopSection';
// import TakeLookSubHeading from '../../../components/TakeALook/TakeALookSubHeading';


import InstagramLogo from '../../../assets/img/customer-service-center/Instagram.png';
import FacebookLogo from '../../../assets/img/customer-service-center/Facebook.png';
import KakaoLogo from '../../../assets/img/customer-service-center/Kakao.png';
import TakeLookSubHeading from '../../../components/TakeALook/TakeLookSubHeading';

// 2) Kakao JS Key 
// const KAKAO_KEY = '14be42c9a3c3c7f2f24153d25810ba11';
const KAKAO_KEY = 'a13a559fb1f5b864d81b8a4a48c07c0c';


const getAbsoluteUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path; // already absolute
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return path.startsWith('/') ? `${origin}${path}` : `${origin}/${path}`;
};


const TakeLookPCOutdoorHall = () => {

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isShareOpen, setIsShareOpen] = useState(false);


  const shareDesktopRef = useRef(null);
  const shareMobileRef = useRef(null);


  const images = [
    { main: '/images/TakeLook/05_Outdoor hall/야외봉안당_01.jpg', thumbnail: '/images/TakeLook/05_Outdoor hall/야외봉안당_01.jpg' },
    { main: '/images/TakeLook/05_Outdoor hall/야외봉안당_02.jpg', thumbnail: '/images/TakeLook/05_Outdoor hall/야외봉안당_02.jpg' },
    { main: '/images/TakeLook/05_Outdoor hall/야외봉안당_03.jpg', thumbnail: '/images/TakeLook/05_Outdoor hall/야외봉안당_03.jpg' },
    { main: '/images/TakeLook/05_Outdoor hall/야외봉안당_04.jpg', thumbnail: '/images/TakeLook/05_Outdoor hall/야외봉안당_04.jpg' },
    { main: '/images/TakeLook/05_Outdoor hall/야외봉안당_05.jpg', thumbnail: '/images/TakeLook/05_Outdoor hall/야외봉안당_05.jpg' },
  ];


  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (window.Kakao) {
      if (!window.Kakao.isInitialized()) window.Kakao.init(KAKAO_KEY);
      return;
    }

    if (!document.getElementById('kakao-sdk')) {
      const script = document.createElement('script');
      script.id = 'kakao-sdk';
      script.src = 'https://developers.kakao.com/sdk/js/kakao.js';
      script.async = true;
      script.onload = () => {
        if (window.Kakao && !window.Kakao.isInitialized()) {
          window.Kakao.init(KAKAO_KEY);
        }
      };
      document.body.appendChild(script);
    }
  }, []);


  useEffect(() => {
    const onOutside = (e) => {
      const d = shareDesktopRef.current;
      const m = shareMobileRef.current;

      if ((d && d.contains(e.target)) || (m && m.contains(e.target))) return;
      setIsShareOpen(false);
    };
    const onEsc = (e) => {
      if (e.key === 'Escape') setIsShareOpen(false);
    };

    document.addEventListener('mousedown', onOutside);
    document.addEventListener('touchstart', onOutside);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('mousedown', onOutside);
      document.removeEventListener('touchstart', onOutside);
      document.removeEventListener('keydown', onEsc);
    };
  }, []);

 
  const handlePrevious = () => setCurrentImageIndex((p) => (p === 0 ? images.length - 1 : p - 1));
  const handleNext = () => setCurrentImageIndex((p) => (p === images.length - 1 ? 0 : p + 1));
  const handleThumbnailClick = (i) => setCurrentImageIndex(i);

 
  const toggleShare = () => setIsShareOpen((v) => !v);


  const handleShareClick = (platform) => {
    const currentUrl = window.location.href;

  
    if (platform === 'facebook') {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
        '_blank',
        'width=600,height=500'
      );
    }


    if (platform === 'instagram') {
      window.open('https://www.instagram.com/', '_blank', 'width=1200,height=800');
    }


    if (platform === 'kakao') {
      const imageUrl = getAbsoluteUrl(images[currentImageIndex].main);

      const fallback = () => {

        window.open(
          `https://story.kakao.com/share?url=${encodeURIComponent(currentUrl)}`,
          '_blank',
          'width=600,height=600'
        );
      };

      try {
        if (window.Kakao && window.Kakao.isInitialized()) {
          window.Kakao.Link.sendDefault({
            objectType: 'feed',
            content: {
              title: document.title || 'Take a Look',
              description: '야외 봉안당 공유하기',
              imageUrl,
              link: {
                mobileWebUrl: currentUrl,
                webUrl: currentUrl,
              },
            },
            buttons: [
              {
                title: '웹에서 보기',
                link: {
                  mobileWebUrl: currentUrl,
                  webUrl: currentUrl,
                },
              },
            ],
          });
        } else {
          fallback();
        }
      } catch (err) {
        fallback();
      }
    }

  
    setIsShareOpen(false);
  };


  return (
    <div className="announcement-list-page take-look-info-page sky-hall-vip-page">
      <TakeLookTopSection />

      <main className="main-content">
        <TakeLookSubHeading heading="야외 봉안당" />

        <div className="take-look-page-content">
          <div className="full-view-content">
            {/* Desktop / Tablet Gallery */}
            <div className="sky-hall-special-room-gallery">
              <div className="sky-hall-special-room-gallery-main-view">
                <img
                  src={images[currentImageIndex].main}
                  alt={`야외 봉안당 큰 이미지 ${currentImageIndex + 1}`}
                  className="sky-hall-special-room-main-image"
                />

                <button
                  className="sky-hall-special-room-gallery-arrow sky-hall-special-room-gallery-arrow-prev"
                  onClick={handlePrevious}
                  aria-label="이전 이미지"
                >
                  <img src="/images/Main/arrow-right-white.png" alt="previous" />
                </button>

                <button
                  className="sky-hall-special-room-gallery-arrow sky-hall-special-room-gallery-arrow-next"
                  onClick={handleNext}
                  aria-label="다음 이미지"
                >
                  <img src="/images/Main/arrow-left-white.png" alt="next" />
                </button>
              </div>

              {/* Thumbnails + Desktop Share */}
              <div className="sky-hall-special-room-gallery-thumbnails-container">
                <div className="sky-hall-special-room-gallery-thumbnails">
                  {images.map((img, i) => (
                    <a
                      key={i}
                      href="#"
                      className={`sky-hall-special-room-thumbnail-item ${i === currentImageIndex ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleThumbnailClick(i);
                      }}
                      aria-current={i === currentImageIndex ? 'true' : 'false'}
                    >
                      <img src={img.thumbnail} alt={`썸네일 ${i + 1}`} />
                    </a>
                  ))}
                </div>

                {/* Share button + popup (desktop) */}
                <div className="full-view-share-section" ref={shareDesktopRef}>
                  <div className="share-container">
                    <button
                      type="button"
                      className="full-view-share-button"
                      aria-haspopup="true"
                      aria-expanded={isShareOpen}
                      aria-controls="share-popup-desktop"
                      onClick={toggleShare}
                    >
                       <span className="share-text">SNS 공유</span>
                      <img src="/images/TakeLook/share.png" alt="공유하기" className="logo" />
                    </button>

                    {isShareOpen && (
                      <div
                        id="share-popup-desktop"
                        className="share-popup"
                        role="dialog"
                        aria-label="공유하기"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="popup-title">공유하기</div>

                        <div className="popup-buttons">
                          <button
                            type="button"
                            className="social-btn"
                            onClick={() => handleShareClick('instagram')}
                            aria-label="Instagram으로 공유하기"
                          >
                            <img src={InstagramLogo} alt="Instagram" className="logo" />
                          </button>

                          <button
                            type="button"
                            className="social-btn"
                            onClick={() => handleShareClick('facebook')}
                            aria-label="Facebook으로 공유하기"
                          >
                            <img src={FacebookLogo} alt="Facebook" className="logo" />
                          </button>

                          <button
                            type="button"
                            className="social-btn"
                            onClick={() => handleShareClick('kakao')}
                            aria-label="KakaoTalk으로 공유하기"
                          >
                            <img src={KakaoLogo} alt="Kakao" className="logo" />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile vertical images + mobile share */}
            <div className="mobile-take-look-main-container">
              <div className="mobile-take-look-main-image-wrapper">
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {images.map((img, i) => (
                    <img
                      key={i}
                      src={img.main}
                      alt={`Outdoor Hall ${i + 1}`}
                      className="mobile-take-look-main-image"
                      style={{ width: '100%', height: 'auto', marginBottom: 10 }}
                    />
                  ))}
                </div>
              </div>

              <div className="mobile-take-look-share-section" ref={shareMobileRef}>
                <div className="share-container">
                  <button
                    type="button"
                    className="mobile-take-look-main-share-btn"
                    aria-haspopup="true"
                    aria-expanded={isShareOpen}
                    aria-controls="share-popup-mobile"
                    onClick={toggleShare}
                  >
                     <span className="share-text">SNS 공유</span>
                    {/* <img src="/images/TakeLook/share-mo.png" alt="공유하기" /> */}
                        <img src="/images/TakeLook/share.png" alt="공유하기" className="logo"/>
                  </button>

                  {isShareOpen && (
                    <div
                      id="share-popup-mobile"
                      className="share-popup"
                      role="dialog"
                      aria-label="공유하기"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="popup-title">공유하기</div>

                      <div className="popup-buttons">
                        <button
                          type="button"
                          className="social-btn"
                          onClick={() => handleShareClick('instagram')}
                          aria-label="Instagram으로 공유하기"
                        >
                          <img src={InstagramLogo} alt="Instagram" className="logo" />
                        </button>

                        <button
                          type="button"
                          className="social-btn"
                          onClick={() => handleShareClick('facebook')}
                          aria-label="Facebook으로 공유하기"
                        >
                          <img src={FacebookLogo} alt="Facebook" className="logo" />
                        </button>

                        <button
                          type="button"
                          className="social-btn"
                          onClick={() => handleShareClick('kakao')}
                          aria-label="KakaoTalk으로 공유하기"
                        >
                          <img src={KakaoLogo} alt="Kakao" className="logo" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
};

export default TakeLookPCOutdoorHall;
